import { useSelector } from 'react-redux';
import LabelCell from 'framework-data-table/contentRenderers/labels/LabelCell';
import PreviewButton from '../frameworkDealTable/PreviewButton';
import { getProperties } from '../../selectors/properties';
import { DEAL_OBJECT_ID } from '../../constants/CrmSearchConstants';
import { ForecastingDealSplitIcon } from '../ForecastingDealSplitIcon';
import { hasDealSplit } from '../../utils/deals';
import { getDealSplitsEnabled } from '../../selectors/portalSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealNameCell = ({
  row,
  columnName,
  requiredCellProps
}) => {
  var _row$properties$prope;
  const dealSplitsEnabled = useSelector(getDealSplitsEnabled);
  const propertyDefinition = useSelector(getProperties)[columnName];
  const showDealSplitIcon = hasDealSplit(row, !!dealSplitsEnabled);
  return /*#__PURE__*/_jsx(LabelCell, {
    object: Object.assign({}, row, {
      objectId: row.id
    }),
    typeDef: {
      objectTypeId: DEAL_OBJECT_ID,
      primaryDisplayLabelPropertyName: propertyDefinition.name
    },
    propertyDefinition: propertyDefinition,
    hoverContent: /*#__PURE__*/_jsx(PreviewButton, {
      dealId: row.id
    }),
    getSecondaryPropertyValue: () => {
      return undefined;
    },
    requiredCellProps: Object.assign({}, requiredCellProps, {
      // This overrides the default tooltip so there are no links or tooltips in it
      tooltip: /*#__PURE__*/_jsxs(_Fragment, {
        children: [(_row$properties$prope = row.properties[propertyDefinition.name]) === null || _row$properties$prope === void 0 ? void 0 : _row$properties$prope.value, showDealSplitIcon && /*#__PURE__*/_jsx(ForecastingDealSplitIcon, {
          tooltipDisabled: true
        })]
      })
    }),
    onClick: () => {}
  });
};
export default DealNameCell;